import { ca } from '@cian/analytics';

import { createDeveloperProduct } from 'shared/utils/analytics';

/**
 * @description Событие: клик по CTA «Выбрать квартиру» (или аналогу) на слайде главной карусели.
 * cta - Call to Action
 */
export function trackMainCarouselSelectApartmentClick(newbuildingId: number, slideIndex: number): void {
  ca('eventSite', {
    action: 'click_main_carousel_cta',
    category: 'Promo',
    label: 'main_carousel_cta_click',
    name: 'oldevent',
    products: [
      createDeveloperProduct({
        extra: {
          items: [
            {
              id: newbuildingId,
              offerType: 'newbuilding_id',
              position: slideIndex,
            },
          ],
        },
      }),
    ],
  });
}
